<template>
  <div id="qmi" class="container-fluid">
    <titular />
    <template v-if="filasRRHH.length">
      <div class="row mb-3">
        <div class="col-12">
          <ul class="list-inline">
            <li class="list-inline-item">
              <button class="btn btn-primary" @click="exportarFilasExcel($refs.tabla.innerHTML)" :disabled="loading.download"><i class="fa-solid fa-download"></i> Exportar en arxiu</button>
            </li>
            <li class="list-inline-item">
              <button class="btn btn-primary" data-toggle="modal" data-target="#modal-movilidad"><i class="fa-solid fa-download"></i> Exportar respostes mobilitat</button>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="filasRRHH.length" ref="tablaContainer" class="table-responsive-sm" @scroll="scroll">
        <table ref="tabla" class="table table-hover table-sm">
          <thead id="sticky-header" class="sticky-top">
            <tr>
              <th scope="col" class="position-sticky table-primary cabecera">
                <ul class="list-inline d-flex justify-content-between mb-0">
                  <li class="list-inline-item">Objectiu <i class="fa-solid fa-turn-up fa-rotate-90 mx-1"></i><span class="sr-only">></span> Indicador</li>
                  <li class="list-inline-item">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="desplegar-todos" v-model="desplegadoTotal">
                      <label class="custom-control-label small" for="desplegar-todos" title="Desplegar tots" v-tooltip>
                        <i class="fa-solid fa-square-caret-down align-bottom"></i>
                      </label>
                    </div>
                  </li>
                </ul>
              </th>
              <th v-for="(fila, index) in meses" :key="`fechainteranual${index}`" scope="col" class="table-primary small align-middle text-center">{{ fila.mes }}/{{ fila.anyo }}</th>
              <th>
                <div v-show="loading.filas" class="spinner-grow spinner-grow-sm text-primary table-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody v-for="(tbody, tIndex) in tbodys" :key="`tbody${tIndex}`">
            <tr>
              <th v-if="tIndex == 0 || tbody.titular != tbodys[tIndex - 1].titular" class="table-secondary px-0" :colspan="(iteracionQMI + 1)">
                <div class="d-flex justify-content-center pr-3 position-sticky" style="max-width: 100vw; left: 0;">{{ tbody.titular }}</div>
              </th>
            </tr>
            <template v-for="(objetivo, oIndex) in objetivos[tbody.objetivo]">
              <cabecera-objetivo :total="(iteracionQMI + 1)" :collapse="`objetivo-${tIndex}-${oIndex}`" :key="`objetivo-${oIndex}`">{{ objetivo }}</cabecera-objetivo>
              <tr v-for="(indicador, index) in indicadores[tbody.objetivo]" :key="`tr${tIndex}-${index}`" v-if="indicador.objetivo == objetivo" ref="collapse" class="collapse" :data-collapse="`objetivo-${tIndex}-${oIndex}`">
                <cabecera-indicador :descripcion="indicador.descripcion" :nombre="indicador.nombre" :id="indicador.columna">
                  <button class="btn btn-link p-0 text-left" data-toggle="modal" data-target="#modal-qmi-graph" @click="abrirChart(indicador, tIndex)">
                    {{ indicador.nombre }}
                  </button>
                </cabecera-indicador>
                <td v-for="(fila, index2) in meses" :key="`sub${tIndex}-${index}-${index2}`" class="text-center align-middle">
                  <span v-if="(tbody.filas[fila.anyo] && tbody.filas[fila.anyo][fila.mes]) && (tbody.filas[fila.anyo][fila.mes][indicador.columna] || tbody.filas[fila.anyo][fila.mes][indicador.columna] == 0)" :class="{ 'badge badge-success': indicador.esPorcentaje && tbody.filas[fila.anyo][fila.mes][indicador.columna] < indicador.porcentajeCorte, 'badge badge-danger': indicador.esPorcentaje && tbody.filas[fila.anyo][fila.mes][indicador.columna] >= indicador.porcentajeCorte }">
                    <span v-if="indicador.esMoneda">{{ formatearDecimales(tbody.filas[fila.anyo][fila.mes][indicador.columna]) }}</span>
                    <span v-else v-html="indicador.decimales ? formatearDecimales(tbody.filas[fila.anyo][fila.mes][indicador.columna], 1) : Math.round(tbody.filas[fila.anyo][fila.mes][indicador.columna])" />
                    <span v-if="indicador.esPorcentaje">%</span>
                    <span v-else-if="indicador.esMoneda">€</span>
                  </span>
                  <template v-else>-</template>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <modal v-if="indicadorChart" modalId="qmi-graph" :titulo="indicadorChart.nombre" icono="fa-solid fa-lock" :clases="['modal-xl']" :loading="false" :esCerrable="true" :hayLanzador="false" @cerrar="cerrarChart">
          <template v-if="indicadorChart.descripcion" v-slot:prebody>
            <div class="alert alert-info rounded-0 mb-0" role="alert">
              {{ indicadorChart.descripcion }}
            </div>
          </template>
          <template v-slot:body>
            <LineChart v-if="chartDataMapped" :chart-data="chartDataMapped" :chart-options="chartOptions"></LineChart>
          </template>
        </modal>
      </div>
    </template>
    <div v-else class="text-center">
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <modal modalId="movilidad" titulo="Mobilitat" icono="fa-solid fa-download" :loading="loading.movilidad" :esCerrable="true" :hayLanzador="false">
      <template v-slot:body>
        <form id="movilidad-form" @submit.prevent="descargarMovilidad">
          <fieldset :disabled="loading.movilidad">
            <div class="form-row">
              <div class="col">
                <div class="form-group">
                  <label for="mobilitat_init">Inici</label>
                  <input type="month" class="form-control" id="mobilitat_init" v-model="mobilitat_init" :min="minMovilidad" :max="mobilitat_end.length ? mobilitat_end : maxMovilidad" required>
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label for="mobilitat_end">Fi</label>
                  <input type="month" class="form-control" id="mobilitat_end" v-model="mobilitat_end" :min="mobilitat_init.length ? mobilitat_init : minMovilidad" :max="maxMovilidad" required>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </template>
      <template v-slot:footer>
        <button class="btn btn-primary" form="movilidad-form" :disabled="loading.movilidad"><i class="fa-solid fa-download"></i> Confirmar</button>
      </template>
    </modal>
  </div>
</template>

<style lang="scss">
#qmi {

  th,
  td {
    &.position-sticky {
      left: 0;
    }
  }

  #sticky-header {
    z-index: 1019;

    @media (min-width: 768px) {
      top: 58px;
    }
  }

  .cabecera {
    min-width: 50vw;
    max-width: 50vw;

    @media (min-width: 768px) {
      min-width: 25vw;
      max-width: 25vw;
    }
  }
}
</style>

<script>
import { Line as LineChart } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement } from 'chart.js'
import CabeceraObjetivo from '@/components/CabeceraObjetivo.vue';
import CabeceraIndicador from '@/components/CabeceraIndicador.vue';

ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement);

export default {
  name: "QMI",
  inject: ["formatearDecimales", "capitalize", "getTonoRandom", "exportarFilasExcel", "exportarDatos"],
  components: {
    CabeceraObjetivo,
    CabeceraIndicador,
    LineChart,
  },
  data() {
    return {
      chartIndex: null,
      loading: {
        filas: false,
        movilidad: false,
      },
      desplegadoTotal: false,
      indicadorChart: null,
      indicadores: {
        interanuales: [
          {
            nombre: "Pes tasca CEO sobre Jordi Prats (interanual)",
            columna: "ceo_pc",
            esPorcentaje: true,
            objetivo: "Desvincular CEO/CMO del dia a dia",
            descripcion: "Hores interanuals treballades en tasca CEO JP (hores Ecostudi) / total hores interanuals JP",
          },
          {
            nombre: "Pes dedicació Ricard sobre Dept. comercial (interanual)",
            columna: "comercial_pc",
            esPorcentaje: true,
            objetivo: "Desvincular CEO/CMO del dia a dia",
            descripcion: "Hores interanuals RV comercials / total hores comercials",
          },
          {
            nombre: "Pes CEO sobre empresa (interanual)",
            columna: "empresa_pc",
            esPorcentaje: true,
            decimales: 1,
            objetivo: "Optimitzar costos gerència",
            descripcion: "Hores interanuals treballades en tasca CEO JP (hores Ecostudi) / total hores interanuals empresa",
          },
          {
            nombre: "Dedicació interanual Jordi Prats",
            columna: "ceo_total",
            objetivo: "Limitar les dedicacions",
            descripcion: "Hores de treball dedicades per Jordi Prats els darrers 12 mesos",
          },
          {
            nombre: "Dedicació interanual Ricard Vizcarra",
            columna: "rv_total",
            objetivo: "Limitar les dedicacions",
            descripcion: "Hores de treball dedicades per Ricard Vizcarra els darrers 12 mesos",
          },
          {
            nombre: "Dedicació interanual Pol Chumillas",
            columna: "pc_total",
            objetivo: "Limitar les dedicacions",
            descripcion: "Hores de treball dedicades per Pol Chumillas els darrers 12 mesos",
          },
          {
            nombre: "Dedicació interanual Xavier Aguilar",
            columna: "xa_total",
            objetivo: "Limitar les dedicacions",
            descripcion: "Hores de treball dedicades per Xavier Aguilar els darrers 12 mesos",
          },
        ],
        RRHH: [
          {
            nombre: "Pes departament comercial (hores) (mensual)",
            columna: "comercial_mensual_pc",
            esPorcentaje: true,
            objetivo: "Reduir el pes i el cost del departament comercial",
            descripcion: "Suma de les hores comercials de cada treballador / hores totals de dedicació",
          },
          {
            nombre: "Pes departament comercial (costos) (mensual)",
            columna: "coste_comercial_pc",
            esPorcentaje: true,
            objetivo: "Reduir el pes i el cost del departament comercial",
            descripcion: "Suma de dedicacions comercials * preu/hora segons treballador / Costos de personal total",
          },
          {
            nombre: "Pes dedicació a Ecostudi (hores) (inclou Varis) (mensual)",
            columna: "ecostudi_pc",
            esPorcentaje: true,
            objetivo: "Incrementar la productivitat dels treballadors",
            descripcion: "Suma de les hores interanuals Ecostudi de cada treballador / hores interanuals totals de dedicació",
          },
          {
            nombre: "Pes dedicació a Ecostudi (costos) (inclou Varis) (mensual)",
            columna: "coste_ecostudi_pc",
            esPorcentaje: true,
            objetivo: "Incrementar la productivitat dels treballadors",
            descripcion: "Suma de les hores interanuals Ecostudi de cada treballador*preu-hora / hores interanuals totals de dedicació",
          },
          {
            nombre: "Hores per projecte (mensual)",
            columna: "horas_proyecto",
            objetivo: "Concentrar i focalitzar la dedicació als projectes tècnics",
            descripcion: "Suma d'hores treballades en projectes facturables / Nombre de projectes facturables en els quals s'ha treballat",
          },
          {
            nombre: "Hores per projecte (>5h/mes) (mensual)",
            columna: "total_5",
            objetivo: "Concentrar i focalitzar la dedicació als projectes tècnics",
          },
          {
            nombre: "Projectes treballats (mensual)",
            columna: "proyectos",
            objetivo: "Concentrar i focalitzar la dedicació als projectes tècnics",
            descripcion: "Suma d'hores treballades en projectes amb dedicació mínima 5h al mes / Nombre de projectes en els quals s'ha treballat un mínim de 5 hores al mes",
          },
          {
            nombre: "Projectes treballats (dedicació >5h) (mensual)",
            columna: "proyectos_5",
            objetivo: "Concentrar i focalitzar la dedicació als projectes tècnics",
          },
          {
            nombre: "% d'hores dedicades a projectes >5h",
            columna: "porcentaje_5",
            esPorcentaje: true,
            objetivo: "Concentrar i focalitzar la dedicació als projectes tècnics",
          },
          {
            nombre: "% saturació oficina tècnica a 3 mesos vista",
            columna: "saturacio",
            esPorcentaje: true,
            objetivo: "Conèixer la capacitat d'assumpció de projectes per part de l'oficina tècnica",
            descripcion: "Hores previstes de dedicació programades dels pròxims 3 mesos / Hores disponibles dels pròxims 3 mesos",
            porcentajeCorte: 90,
          },
          {
            nombre: "Hores lliures mes 1",
            columna: "hores_lliures_1",
            esPorcentaje: false,
            objetivo: "Conèixer la capacitat d'assumpció de projectes per part de l'oficina tècnica",
          },
          {
            nombre: "Hores lliures mes 2",
            columna: "hores_lliures_2",
            esPorcentaje: false,
            objetivo: "Conèixer la capacitat d'assumpció de projectes per part de l'oficina tècnica",
          },
          {
            nombre: "Hores lliures mes 3",
            columna: "hores_lliures_3",
            esPorcentaje: false,
            objetivo: "Conèixer la capacitat d'assumpció de projectes per part de l'oficina tècnica",
          },
          {
            nombre: "Hores lliures mes 4",
            columna: "hores_lliures_4",
            esPorcentaje: false,
            objetivo: "Conèixer la capacitat d'assumpció de projectes per part de l'oficina tècnica",
          },
          {
            nombre: "Hores lliures mes 5",
            columna: "hores_lliures_5",
            esPorcentaje: false,
            objetivo: "Conèixer la capacitat d'assumpció de projectes per part de l'oficina tècnica",
          },
          {
            nombre: "Hores lliures mes 6",
            columna: "hores_lliures_6",
            esPorcentaje: false,
            objetivo: "Conèixer la capacitat d'assumpció de projectes per part de l'oficina tècnica",
          },
          {
            nombre: "Hores lliures acumulades pròxims 6 mesos",
            columna: "hores_acumulades",
            esPorcentaje: false,
            objetivo: "Conèixer la capacitat d'assumpció de projectes per part de l'oficina tècnica",
          },
        ],
        comercial: [
          {
            nombre: "Hores CMO",
            columna: "horas_cmo",
            objetivo: "Fer seguiment de la dedicació comercial",
          },
          {
            nombre: "Hores Comercial (Eva)",
            columna: "horas_eva",
            objetivo: "Fer seguiment de la dedicació comercial",
          },
          {
            nombre: "Hores comercials altres treballadors",
            columna: "horas_resto",
            objetivo: "Fer seguiment de la dedicació comercial",
          },
          {
            nombre: "Hores totals comercials",
            columna: "horas_totales",
            objetivo: "Fer seguiment de la dedicació comercial",
          },
          {
            nombre: "Pressupostos presentats",
            columna: "pressupostos_presentats",
            objetivo: "Conèixer l'activitat del departament comercial",
          },
          {
            nombre: "Pressupostos acceptats",
            columna: "pressupostos_acceptats",
            objetivo: "Conèixer l'activitat del departament comercial",
          },
          {
            nombre: "Import pressupostos presentats",
            columna: "total_presentats",
            esMoneda: true,
            objetivo: "Conèixer l'activitat del departament comercial",
          },
          {
            nombre: "Import pressupostos acceptats",
            columna: "total_acceptats",
            esMoneda: true,
            objetivo: "Conèixer l'activitat del departament comercial",
          },
          {
            nombre: "Hores comercials directes RV (mensuals)",
            columna: "horas_directas",
            objetivo: "Fer seguiment de l'activitat del CMO",
          },
          {
            nombre: "Hores comercials directes a licitacions RV (mensuals)",
            columna: "horas_licitaciones",
            objetivo: "Fer seguiment de l'activitat del CMO",
          },
          {
            nombre: "Hores dedicades a RRPP",
            columna: "horas_rrpp",
            objetivo: "Fer seguiment de l'activitat del CMO",
          },
        ],
        punteco: [
          {
            nombre: "Horts totals en lloguer CP",
            columna: "horts_cappont",
            objetivo: "Incrementar la rendibilitat dedicació horts",
            esPorcentaje: true,
          },
          {
            nombre: "Horts totals en lloguer Pardinyes",
            columna: "horts_pardinyes",
            objetivo: "Incrementar la rendibilitat dedicació horts",
            esPorcentaje: true,
          },
        ],
        felicidad: [
          {
            nombre: "Felicitat global",
            columna: "pcGlobal",
            objetivo: "Promoure la felicitat entre els treballadors",
            descripcion: "Puntuació real respecte puntuació màxima possible.",
            esPorcentaje: true,
          },
          {
            nombre: "Dies amb felicitat que es manté o incrementa entre matí i tarda",
            columna: "pcMantenido",
            objetivo: "Promoure la felicitat entre els treballadors",
            descripcion: "Percentatge de dies que es manté o s'incrementa la felicitat",
            esPorcentaje: true,
          },
          {
            nombre: "Puntuació de mobilitat",
            columna: "pcMovilidad",
            objetivo: "Promoure la felicitat entre els treballadors",
            descripcion: "peu, bici, bus = 4 punts; teletreball = 3 punts; cotxe 1 punt",
            esPorcentaje: true,
          },
        ]
      },
      filasRRHHInteranuales: [],
      filasRRHH: [],
      filasComercial: [],
      filasMensuales: [],
      filasQA: [],
      iteraciones: 0,
      mobilitat_init: "",
      mobilitat_end: "",
      minMovilidad: "2022-12", // HARDCODED fecha de la primera respuesta de este tipo
    };
  },
  computed: {
    maxMovilidad() {
      return new Date().toISOString().slice(0, 7);
    },
    chartOptions() {
      const that = this;

      return {
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              callback(value, index, ticks) {
                if (that.indicadorChart?.esPorcentaje) return `${value}%`;
                if (that.indicadorChart?.esMoneda) return `${value}€`;

                return value;
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label(context) {
                if (that.indicadorChart?.esPorcentaje) return that.indicadorChart?.decimales ? `${that.formatearDecimales(context.raw, 1)}%` : `${Math.round(context.raw)}%`;
                if (that.indicadorChart?.esMoneda) return `${Math.round(context.raw)}€`;

                return that.indicadorChart?.decimales ? that.formatearDecimales(context.raw, 1) : Math.round(context.raw);
              },
            },
          },
        },
      };
    },
    tbodys() {
      const filasMensualesMapeadas = this.mapearFilas(this.filasMensuales);

      return [
        {
          objetivo: "interanuales",
          filas: this.mapearFilas(this.filasRRHHInteranuales),
          titular: "RRHH",
        },
        {
          objetivo: "RRHH",
          filas: this.mapearFilasMerge(this.filasRRHH, filasMensualesMapeadas),
          titular: "RRHH",
        },
        {
          objetivo: "comercial",
          filas: this.mapearFilasMerge(this.filasComercial, filasMensualesMapeadas),
          titular: "Departament comercial",
        },
        {
          objetivo: "punteco",
          filas: filasMensualesMapeadas,
          titular: "Punteco",
        },
        {
          objetivo: "felicidad",
          filas: this.mapearFilasMerge(this.filasQA, filasMensualesMapeadas),
          titular: "Cultura empresarial",
        },
      ];
    },
    iteracionQMI() {
      return this.iteraciones * 12;
    },
    objetivos() {
      let objetivos = {};

      Object.keys(this.indicadores).forEach(a => objetivos[a] = [...new Set(this.indicadores[a].map(a => a.objetivo))]);

      return objetivos;
    },
    meses() {
      const meses = [];

      for (let i = 1; i <= this.iteracionQMI; i++) {
        const day = new Date();
        day.setDate(1);
        day.setMonth(day.getMonth() - i);
        meses.push({ "mes": day.getMonth() + 1, "anyo": day.getFullYear() });
      }

      return meses;
    },
    chartDataMapped() {
      if (!this.indicadorChart) return;
      if (this.chartIndex == null) return;

      const labels = [];

      for (let i = 0; i < 12; i++) {
        const date = new Date(0, i, 1);

        labels.push(this.capitalize(date.toLocaleString('default', { month: 'long' })));
      }

      const datasets = Object.keys(this.tbodys[this.chartIndex].filas).map(anyo => {
        const data = [];

        for (let i = 1; i <= 12; i++) {
          if (this.tbodys[this.chartIndex].filas[anyo][i]) data.push(this.tbodys[this.chartIndex].filas[anyo][i][this.indicadorChart.columna]);
        }

        return {
          label: anyo,
          borderColor: `rgb(${[this.getTonoRandom(), this.getTonoRandom(), this.getTonoRandom()].join(",")})`,
          tension: 0.2,
          data
        }
      });

      return {
        labels,
        datasets
      };
    },
  },
  created() {
    const today = new Date();
    const quarter = Math.floor((today.getMonth() / 3));
    const startFullQuarter = new Date(today.getFullYear(), quarter * 3 - 3, 1);
    const endFullQuarter = new Date(startFullQuarter.getFullYear(), startFullQuarter.getMonth() + 3, 0);

    this.mobilitat_init = `${startFullQuarter.getUTCFullYear()}-${(startFullQuarter.getMonth() + 1).toString().padStart(2, '0')}`;
    this.mobilitat_end = `${endFullQuarter.getUTCFullYear()}-${(endFullQuarter.getMonth() + 1).toString().padStart(2, '0')}`;
  },
  mounted() {
    this.fetchFilas();

    window.onscroll = (e) => this.scrollWindow();
  },
  methods: {
    mapearFilasMerge(filas, filas2) {
      const filasMapeadas = {};

      filas.forEach(fila => {
        if (!filasMapeadas[fila.anyo]) filasMapeadas[fila.anyo] = {};

        filasMapeadas[fila.anyo][fila.mes] = { ...fila, ...filas2?.[fila.anyo]?.[fila.mes] };

      });

      return filasMapeadas;
    },
    mapearFilas(filas) {
      const filasMapeadas = {};

      filas.forEach(fila => {
        if (!filasMapeadas[fila.anyo]) filasMapeadas[fila.anyo] = {};

        filasMapeadas[fila.anyo][fila.mes] = fila;
      });

      return filasMapeadas;
    },
    scrollWindow() {
      // Ocurre en todo momento y filtramos para sm en adelante con window.pageXOffset
      if (window.pageXOffset && (window.innerWidth + window.scrollX) >= document.body.scrollWidth) {
        this.fetchFilas();
      }
    },
    scroll: function (e) {
      // Solo ocurre en xs
      const maxScroll = e.target.scrollWidth - e.target.clientWidth;

      if (e.target.scrollLeft == maxScroll) {
        this.fetchFilas();
      }
    },
    async fetchFilas() {
      if (this.loading.filas) return;

      this.loading.filas = true;

      await this.$http
        .get(`api/mensuals?${new URLSearchParams({ qmi: this.iteracionQMI })}`)
        .then(response => this.filasMensuales = [...this.filasMensuales, ...response.data ?? []]);

      this.$http
        .get(`${process.env.VUE_APP_QA_SERVER_URL}api/respostes?${new URLSearchParams({ qmi: this.iteracionQMI })}`)
        .then(response => this.filasQA = [...this.filasQA, ...response.data]);

      this.$http
        .get(`api/dedicacions?${new URLSearchParams({ qmi: this.iteracionQMI })}`)
        .then((response) => {
          this.filasRRHHInteranuales = [...this.filasRRHHInteranuales, ...response.data.filas_rrhh_interanuales ?? []];
          this.filasRRHH = [...this.filasRRHH, ...response.data.filas_rrhh ?? []];
          this.filasComercial = [...this.filasComercial, ...response.data.filas_comercial ?? []];
          this.iteraciones++;
        })
        .finally(() => (this.loading.filas = false));
    },
    abrirChart(indicador, index) {
      this.indicadorChart = indicador;

      this.chartIndex = index;
    },
    cerrarChart() {
      this.indicadorChart = null;
      this.chartIndex = null;
    },
    descargarMovilidad() {
      this.loading.movilidad = true;

      this.$http
        .get(`${process.env.VUE_APP_QA_SERVER_URL}api/respostes?${new URLSearchParams({ mobilitat_init: this.mobilitat_init, mobilitat_end: this.mobilitat_end })}`)
        .then(response => {
          if (response.data.length) {
            response.data.unshift(Object.keys(response.data[0]));

            this.exportarDatos("Mobilitat", response.data);

            this.$toast.success("Descarregant arxiu…");
          } else {
            this.$toast.error("No hi ha respostes en aquest rang de dates");
          }
        })
        .finally(() => this.loading.movilidad = false);
    },
  },
  watch: {
    filasRRHH() {
      this.$nextTick(() => {
        if (this.$refs.tablaContainer.scrollWidth - this.$refs.tablaContainer.clientWidth == 0) {
          this.fetchFilas();
        }
      });
    },
    desplegadoTotal(value) {
      this.$refs.collapse.forEach(a => $(a).collapse(value ? 'show' : 'hide'));
    },
  },
};
</script>